
(() => {
  const offers = {
    a: { name: 'A · Signature', price: 9900, pieces: "Three",
      contents: "1 key board · 1 acrylic block · 1 RoboTap Keychain", note: "3 pieces · 1 RoboTap Keychain" },
    b: { name: 'B · Complete', price: 11900, pieces: "Four",
      contents: "1 phone case · 1 acrylic block · 1 key board · 1 RoboTap Keychain", note: "4 pieces · 1 RoboTap Keychain" }
  };
  const gallery = {
    a: ["SIGNATURE SET · 3 PIECES", "Signature Set with key board, acrylic block and one opaque RoboTap Keychain with a corner hole"],
    b: ["COMPLETE SET · 4 PIECES", "Complete Set with phone case, acrylic block, key board, RoboTap Keychain with a corner hole"],
    key: ["ROBOTAP · WITH NFC", "Opaque square RoboTap Keychain with corner hole and black clasp"],
    board: ["IN BOTH SETS", "Personalised key board with two hooks"]
  };
  const money = cents => new Intl.NumberFormat("en-IE", { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(cents / 100);
  class CarCombo extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-combo-config]').textContent);
      this.form = this.querySelector('[data-config-form]');
      this.model = this.querySelector('#cc-phone');
      this.file = this.querySelector('#cc-photo');
      this.review = this.querySelector('[data-review-dialog]');
      this.cartButton = this.querySelector('[data-cart-button]');
      this.live = this.dataset.purchaseEnabled === 'true' && this.config.currency === 'EUR';
      this.set = 'b'; this.imageKey = 'b'; this.photoReady = false; this.fileSerial = 0;
      this.querySelectorAll('[name=combo]').forEach(input => input.addEventListener('change', () => { this.select(input.value); }));
      this.querySelectorAll('[data-select-set]').forEach(button => button.addEventListener('click', () => {
        this.select(button.dataset.selectSet);
      }));
      this.querySelectorAll('[data-gallery]').forEach(button => button.addEventListener('click', () => this.select(button.dataset.gallery)));
      this.querySelector('[data-zoom]').addEventListener('click', () => {
        const im = this.querySelector('[data-zoom-image]');
        im.src = this.config.assets[this.imageKey].large; im.alt = gallery[this.imageKey][1];
        this.querySelector('[data-image-dialog]').showModal();
      });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelectorAll('[data-close-dialog]').forEach(button => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      });
      this.file.addEventListener('change', () => this.loadPhoto());
      this.querySelector('[data-remove-photo]').addEventListener('click', () => this.clearPhoto());
      this.model.addEventListener('change', () => this.syncVariant());
      this.querySelector('#cc-link').addEventListener('input', event => event.target.setCustomValidity(''));
      this.form.addEventListener('submit', event => { event.preventDefault(); this.kit.advance(); });
      this.cartButton.addEventListener('click', () => this.addToCart());
      this.select(this.dataset.initialSet === 'a' ? 'a' : 'b', { previewOnly: true });
      this.kit = new window.RoboPixelCarKit(this);
      // Owner choice 2026-10-26: Signature is pre-selected; Complete stays one tap away.
      this.select('a');
      this.querySelector('[data-review-button]').disabled = false;
    }
    disconnectedCallback() { this.kit?.editor?.dispose();this.kit?.itemViewer?.dispose(); if (this.photoUrl) URL.revokeObjectURL(this.photoUrl); }
    scrollBehavior() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    select(key, { previewOnly = false } = {}) {
      if (!offers[key]) return;
      this.editionChosen = !previewOnly; this.classList.toggle('cc--choose-edition', previewOnly);
      this.set = key; this.model.required = key === 'b'; this.model.disabled = key === 'a'; this.model.closest('.cc-field').hidden = key === 'a'; this.querySelector('[data-signature-note]').hidden = key !== 'a'; const offer = offers[key];
      this.querySelectorAll('[name=combo]').forEach(input => { input.checked = this.editionChosen && input.value === key; });
      this.querySelectorAll('[data-price]').forEach(el => { el.textContent = this.editionChosen ? money(offer.price) : money(9900) + '–' + money(11900); });
      this.querySelectorAll('[data-set-name]').forEach(el => { el.textContent = this.editionChosen ? offer.name : "Choose your edition"; });
      this.querySelector('[data-piece-count]').textContent = offer.pieces;
      this.querySelector('[data-selection-note]').textContent = offer.note;
      this.querySelector('[data-edition-property]').value = this.editionChosen ? offer.name : '';
      this.querySelector('[data-contents-property]').value = offer.contents;
      this.querySelectorAll('[data-b-only]').forEach(el => {
        el.hidden = key !== 'b'; el.querySelectorAll('input').forEach(input => { input.disabled = key !== 'b'; });
      });
      this.querySelector('[data-config-image]').src = this.config.assets[key].medium;
      this.showImage(key); this.populateModels();
      this.kit?.onSetChange();
      if (this.review.open) this.review.close();
    }
    showImage(key) {
      if (!this.config.assets[key]) return;
      this.imageKey = key;
      const source = this.config.assets[key], im = this.querySelector('[data-main-image]');
      im.srcset = `${source.small} 480w, ${source.medium} 800w, ${source.large} 1254w`;
      im.src = source.medium; im.alt = gallery[key][1];
      this.querySelector('[data-image-label]').textContent = gallery[key][0];
      this.querySelectorAll('[data-gallery]').forEach(button => button.setAttribute('aria-pressed', String(this.editionChosen && button.dataset.gallery === this.set)));
      this.kit?.updateHotspots();
    }
    availablePhoneTitles() {
      // A preview image alone does not mean the model can be ordered.
      const available = new Set((this.config.variants.b || []).filter(v => v.available && v.price === offers.b.price).map(v => v.title));
      return [...new Set((this.config.phones || []).filter(p => p.blank && available.has(p.title)).map(p => p.title))];
    }
    populateModels() {
      const before = this.model.value;
      const titles = this.availablePhoneTitles();
      this.model.replaceChildren(new Option("Choose your phone model", ''));
      for (const brand of ['Apple', 'Samsung']) {
        const group = document.createElement('optgroup'); group.label = brand;
        titles.filter(title => brand === 'Apple' ? title.startsWith('iPhone') : title.startsWith('Galaxy')).forEach(title => group.append(new Option(title, title)));
        if (group.children.length) this.model.append(group);
      }
      if (titles.includes(before)) this.model.value = before;
      this.syncVariant();
    }
    syncVariant() {
      this.variant = this.editionChosen && (this.config.variants[this.set] || []).find(v => (this.set === 'a' ? v.title === 'Default Title' : v.title === this.model.value) && v.available && v.price === offers[this.set].price);
      const input = this.querySelector('[data-variant-id]');
      input.value = this.variant?.id || ''; input.disabled = !this.live || !this.variant;
      const note=this.querySelector('[data-model-note]');note.hidden=!this.live||!this.model.value||!!this.variant;note.textContent=document.documentElement.lang.startsWith('en')?'This model is not currently available to order. Please choose another model.':'Dieses Modell ist derzeit nicht bestellbar. Bitte wähle ein anderes Modell.';
    }
    clearPhoto() {
      this.fileSerial++;
      if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      this.photoUrl = null; this.photoReady = false; this.file.value = '';
      this.file.setCustomValidity('');
      this.querySelector('[data-upload-title]').textContent = "Choose a photo";
      this.querySelector('.cc-upload-preview').hidden = true;
      this.querySelector('#cc-file-error').hidden = true;
      this.kit?.onUploadChange();
    }
    async loadPhoto() {
      const file = this.file.files[0];
      const serial = ++this.fileSerial;
      if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
      this.photoUrl = null; this.photoReady = false;
      this.querySelector('.cc-upload-preview').hidden = true;
      this.querySelector('#cc-file-error').hidden = true;
      this.file.setCustomValidity('');
      if (!file) return;
      let error = '';
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) error = "Please choose a JPG, PNG or WEBP photo.";
      else if (file.size > 15 * 1024 * 1024) error = "This photo is too large. Please choose a file up to 15 MB.";
      else if (!file.size) error = "This file is empty. Please choose another photo.";
      if (!error) {
        const url = URL.createObjectURL(file);
        const im = new Image(); im.src = url;
        try { await im.decode(); }
        catch { error = "This photo cannot be opened. Please choose another file."; }
        if (serial !== this.fileSerial) { URL.revokeObjectURL(url); return; }
        if (!error) {
          this.photoUrl = url; this.photoReady = true;
          this.querySelector('[data-upload-preview]').src = url;
          this.querySelector('.cc-upload-preview').hidden = false;
          this.querySelector('[data-upload-title]').textContent = file.name;
        } else URL.revokeObjectURL(url);
      }
      if (error) {
        this.file.setCustomValidity(error);
        this.querySelector('#cc-file-error').textContent = error;
        this.querySelector('#cc-file-error').hidden = false;
        this.querySelector('[data-upload-title]').textContent = "Choose another photo";
      }
      this.kit?.onUploadChange();
    }
    valid() {
      if (!this.editionChosen) { this.kit?.focusEditions(); return false; }
      const error = this.querySelector('[data-form-error]'); error.hidden = true;
      const link = this.querySelector('#cc-link');
      link.setCustomValidity('');
      if (link.value.trim()) {
        try { const url = new URL(link.value); if (!['http:', 'https:'].includes(url.protocol)) throw Error(); }
        catch { link.setCustomValidity("Please enter a complete http:// or https:// link."); }
      }
      const project = this.querySelector('#cc-name');
      if (this.set === 'b' && !(this.config.phones || []).some(phone => phone.title === this.model.value && phone.blank)) {
        error.textContent = document.documentElement.lang.startsWith('en') ? 'Choose your phone model to use its matching case.' : 'Wähle dein Handymodell für die passende Hülle.'; error.hidden = false; return false;
      }
      project.setCustomValidity(project.value.trim() ? '' : "Please enter a name.");
      project.addEventListener('input', () => project.setCustomValidity(''), { once: true });
      this.kit.revealInvalid();
      if (!this.form.reportValidity()) return false;
      if (!this.kit.readyForPreview()) { error.textContent = document.documentElement.lang.startsWith('en') ? 'Please upload a valid design for every included item.' : 'Bitte lade für jeden enthaltenen Artikel ein gültiges Motiv hoch.'; error.hidden = false; return false; }
      this.syncVariant();
      if (this.live && !this.variant) { error.textContent = "This combination is currently unavailable. Please choose another model."; error.hidden = false; return false; }
      return true;
    }
    openReview(sourceOnly = false) {
      if (!this.valid() || (!sourceOnly && !this.kit.result)) return;
      // Freeze the chosen route: an in-flight result must not silently change it.
      this.reviewSelection={result:sourceOnly?null:this.kit.result,version:this.kit.version,sourceOnly};
      this.kit.track('order_review',{route:sourceOnly?'source-only':'preview-selected'});
      const data = new FormData(this.form), offer = offers[this.set];
      const photo=this.querySelector('[data-review-photo]');
      photo.hidden=sourceOnly;photo.alt=document.documentElement.lang.startsWith('en')?'Your selected kit design':'Dein gewähltes Setdesign';
      if(sourceOnly)photo.removeAttribute('src');else photo.src=this.reviewSelection.result.url;
      this.querySelector('[data-review-disclaimer]').textContent=sourceOnly?this.kit.sourceNotice:this.kit.previewNotice;
      const rows = [['Edition', offer.name], ["Phone model", this.set === 'b' ? this.model.value : '—'], ['Name', data.get('properties[Name]')], ["Style", data.get('properties[Design style]')], ["RoboTap Keychain", data.get('properties[NFC keychain name]') || "No name"]];
      if (data.get('properties[Project name]')?.trim()) rows.push(['Project name',data.get('properties[Project name]')]);
      rows.push(['RoboTap', document.documentElement.lang.startsWith('en') ? 'Activate and configure in your dashboard after delivery' : 'Nach Erhalt im Dashboard aktivieren und einrichten']);
      if (data.get('properties[Design notes]')) rows.push(["Requests", data.get('properties[Design notes]')]);
      const dl = this.querySelector('[data-review-details]'); dl.replaceChildren();
      rows.forEach(([key,value]) => { const row = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = key; dd.textContent = value; row.append(dt,dd); dl.append(row); });
      this.querySelector('[data-review-contents]').textContent = offer.contents;
      this.querySelector('[data-review-status]').textContent = this.live ? (document.documentElement.lang.startsWith('en') ? 'Your saved design is the final design preview. We may make small adjustments for the best print results.' : 'Dein gespeichertes Design ist die finale Designvorschau. Kleine Anpassungen für das beste Druckergebnis sind möglich.') : "Preview: your selection has not been ordered or uploaded. The collection is not yet available to order.";
      if(sourceOnly)this.querySelector('[data-review-status]').textContent=document.documentElement.lang.startsWith('en')?'Your photos and design instructions will be attached to your order. No preview has been selected.':'Deine Fotos und Gestaltungsangaben werden der Bestellung beigefügt. Es wurde keine Vorschau ausgewählt.';
      this.cartButton.disabled = !this.live || !this.variant;
      this.review.showModal();
    }
    async addToCart() {
      if (!this.live || this.checkingOut || !this.reviewSelection || !this.valid()) return;
      const {result,version,sourceOnly}=this.reviewSelection;
      if(version!==this.kit.version||(!sourceOnly&&result!==this.kit.result))return;
      this.kit.editor?.freeze();this.checkingOut=true;this.cartButton.disabled=true;this.form.inert=true;this.kit.updateGuide();
      try {
        const editor=this.config.editor?await this.kit.ensureEditor():null;
        const layoutPackage=editor?await editor.orderPackage():null;
        await window.RoboPixelCarCheckout(this.form,result,this.config.kit,{sourceOnly,english:document.documentElement.lang.startsWith('en'),brief:this.kit.productionBrief(),layoutPackage});
        if(this.kit.version!==version||(!sourceOnly&&this.kit.result!==result))throw Error('Changed design');
        this.kit.track('cart_submit',{route:sourceOnly?'source-only':'preview-selected'});
        this.form.inert=false;HTMLFormElement.prototype.submit.call(this.form);
      } catch {
        this.kit.editor?.resume();this.form.inert=false;this.checkingOut=false;this.cartButton.disabled=false;
        this.kit.setStatus(document.documentElement.lang.startsWith('en')?'We could not save your order details. Please try again.':'Deine Bestelldaten konnten nicht gespeichert werden. Bitte versuche es erneut.');
        this.querySelector('[data-review-status]').textContent=document.documentElement.lang.startsWith('en')?'We could not save your order details. Please try again.':'Deine Bestelldaten konnten nicht gespeichert werden. Bitte versuche es erneut.';
      }
    }
  }
  if (!customElements.get('car-combo')) customElements.define('car-combo', CarCombo);
})();
